import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    OtherLiabilitiesResponse,
    OtherLiabilitiesState,
    OtherLiabilitiesSubmitResponse,
    OtherLiabilityDetails,
    UpdateOtherLiabilitiesEndpoints,
} from './otherLiabilitiesTypes';
import { initialStateOtherLiabilities as initialState } from './otherLiabilitiesDefaultValue';
import { ApiStatus } from '../../types';
const otherLiabilitiesSlice = createSlice({
    name: 'otherLiabilities',
    initialState,
    reducers: {
        openOtherLiabilitiesAddMode: (state) => {
            state.isAddMode = true;
        },
        saveAndCloseOtherLiabilitiesAddMode: (state, action: PayloadAction<OtherLiabilityDetails>) => {
            const lastIndex = Object.keys(state.otherLiabilities).length;

            state.otherLiabilities[lastIndex] = action.payload;

            state.isAddMode = false;
            state.lastVisitedItem = {
                id: lastIndex,
                mode: 'add',
                isSaved: true,
            };
        },
        cancelAndCloseOtherLiabilitiesAddMode: (state) => {
            state.isAddMode = false;
            state.lastVisitedItem = {
                id: null,
                mode: 'add',
                isSaved: false,
            };
        },
        openOtherLiabilitiesEditMode: (state, action: PayloadAction<number>) => {
            state.otherLiabilities[action.payload] = {
                ...state.otherLiabilities[action.payload],
                recordNumber: action.payload,
                isEditMode: true,
            };

        },
        saveAndCloseOtherLiabilitiesEditMode: (state, action: PayloadAction<OtherLiabilityDetails>) => {
            const recordNumber = action.payload.recordNumber ?? 0;

            state.otherLiabilities[recordNumber] = action.payload;
            state.otherLiabilities[recordNumber].isEditMode = false;
            state.lastVisitedItem = {
                id: recordNumber,
                mode: 'edit',
                isSaved: true,
            };
        },
        cancelAndCloseOtherLiabilitiesEditMode: (state, action: PayloadAction<number | undefined>) => {
            const recordNumber = action.payload ?? 0;

            state.otherLiabilities[recordNumber].isEditMode = false;
            state.lastVisitedItem = {
                id: recordNumber,
                mode: 'edit',
                isSaved: false,
            };
        },
        getOtherLiabilities: (state) => {
            state.apiStatus = ApiStatus.Pending;
        },
        getOtherLiabilitiesFulfilled: (state, action: PayloadAction<OtherLiabilitiesResponse>) => {
            const { content, otherLiabilities, referenceData } = action.payload;

            if (content) {
                state.content = JSON.parse(content);
            }
            state.otherLiabilities = otherLiabilities;
            state.referenceData = referenceData;
            state.apiStatus = ApiStatus.Fulfilled;
        },
        getOtherLiabilitiesRejected: (state) => {
            state.apiStatus = ApiStatus.Rejected;
        },
        deleteOtherLiabilities: (state, action: PayloadAction<number>) => {
            state.otherLiabilities[action.payload].isDeleted = true;
        },
        submitOtherLiabilities: (state, action: PayloadAction<Record<number, OtherLiabilityDetails>>) => state,
        submitOtherLiabilitiesFulfilled: (state, action: PayloadAction<OtherLiabilitiesSubmitResponse>) => {
            const { otherLiabilities } = action.payload;

            state.otherLiabilities = otherLiabilities;

        },
        submitOtherLiabilitiesRejected: (state) => state,
        updateOtherLiabilitiesEndpoints: (state, action: PayloadAction<UpdateOtherLiabilitiesEndpoints>) => {
            state.apiEndPoints = {
                ...state.apiEndPoints,
                ...action.payload,
            };
        },

        resetOtherLiabilitiesStatus(state) {
            state.apiStatus = ApiStatus.Idle;
        },
        resetLastVisitedItem(state) {
            state.lastVisitedItem = {
                id: null,
                mode: null,
                isSaved: false,
            };
        },
    },
});

export const {
    openOtherLiabilitiesAddMode,
    saveAndCloseOtherLiabilitiesAddMode,
    cancelAndCloseOtherLiabilitiesAddMode,
    openOtherLiabilitiesEditMode,
    saveAndCloseOtherLiabilitiesEditMode,
    cancelAndCloseOtherLiabilitiesEditMode,
    getOtherLiabilities,
    getOtherLiabilitiesFulfilled,
    getOtherLiabilitiesRejected,
    deleteOtherLiabilities,
    submitOtherLiabilities,
    submitOtherLiabilitiesFulfilled,
    submitOtherLiabilitiesRejected,
    updateOtherLiabilitiesEndpoints,
    resetOtherLiabilitiesStatus,
    resetLastVisitedItem,
} = otherLiabilitiesSlice.actions;

export const otherLiabilitiesReducer: Reducer<OtherLiabilitiesState, AnyAction> = otherLiabilitiesSlice.reducer;
